import { formatCurrency } from "@nf/common";
import { useTranslation } from "next-i18next";
import cx from "classnames";

import { useLanguage } from "hooks";
import { IPaymentDataProps } from "../types";

import styles from "./OfferPrice.module.scss";

const OfferPrice = ({
  price,
  currency,
  period,
  savings,
  savingsLabel,
}: IPaymentDataProps) => {
  const { t } = useTranslation("translations");
  const language = useLanguage();

  return (
    <div className={styles.container}>
      <span
        className={cx(styles.savings, {
          [styles.savingsLabel]: savingsLabel,
        })}
      >
        {savingsLabel
          ? savingsLabel
          : savings && formatCurrency(savings, currency, language)}
      </span>
      <span className={styles.price}>{price}</span>
      <span className={styles.currency}>{`${formatCurrency(
        null,
        currency,
        language
      )}${t(`web_payment_period_${period}`)}`}</span>
    </div>
  );
};

export default OfferPrice;
